import apiService from 'src/enviroment';
import { loaderService } from './loaderService';

const pricesService = {
  getPrices: () => apiService.get('/segmentacion/maestros/precios/'),
  putPrices: (params) => {
    // La celda se muestra formateada con separadores de miles, así que el
    // valor editado puede llegar como "11,499,999".
    const body = {
      uuid: params.newData.uuid,
      precio: Number(String(params.newData.precio).replace(/[^\d.-]/g, '')),
    };
    return apiService.put('/segmentacion/maestros/precios/', body);
  },
  postMail: (body) => apiService.post('/monitoreo/preciosvariacion/', body),
  postState: (params) => {
    const body = {
      uuid: params.uuid,
      estado: params.tableData.estado,
    };
    return apiService.post('/segmentacion/maestros/precios/', body);
  },
  getScraping: async (uuid) => {
    try {
      const response = await apiService.get(
        `/scraping/precios/?segmentacion_uuid=${uuid}`,
      );
      if (response.status === 200) {
        return response.data.data;
      }
    } catch (error) {
      return false;
    }
  },
  updateScraping: async (params) => {
    try {
      const body = {
        segmentacion_uuid: params.segmentacion_uuid,
        url: params.url ?? '',
        xpath: params.xpath ?? '',
        estado: Number(params.estado ?? 1),
      };
      const response = await apiService.put('/scraping/precios/', body);
      return response.status === 200 && response.data?.success !== 0;
    } catch (error) {
      console.log(error);
      return false;
    }
  },

  postPromotion: async (body) => {
    loaderService.show();
    try {
      const response = await apiService.post(
        'segmentacion/maestros/promociones/',
        body,
      );
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return false;
    } finally {
      loaderService.hide();
    }
  },
  deletePromotion: async (uuid) => {
    loaderService.show();
    try {
      const response = await apiService.delete(
        `segmentacion/maestros/promociones/?uuid=${uuid}&fecha_desactivacion=${new Date().toISOString().slice(0, 10)}`,
      );
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return false;
    } finally {
      loaderService.hide();
    }
  },
};

export default pricesService;
